import React from 'react'
import { redirectWithCookies } from '../../utils/Utm'
import Picture from '../../components/Picture'
import './CallToActionSection.scss'


const CallToActionSection = () => {
    return (
        <section className="call-to-action-section">
            <div className="radial-bg purple small"></div>
            <div className="container">
                <div className="content-wrapper">
                    <div className="left-content">
                        <p className="title">Conheça nossos planos e teste grátis</p>
                        <p className="description">
                            Mais de 9.000 empresas confiam no Mercos para
                            impulsionar a automação da força de vendas
                        </p>

                        <div className="buttons-wrapper">
                            <button
                                className="new-form-btn new-form-btn-solid-green"
                                onClick={() => redirectWithCookies('https://app.mercos.com/cadastro/')}
                                href='#'
                                title='Faça um teste grátis'
                            >
                                Faça um teste grátis
                            </button>
                            <a className="new-form-btn new-form-btn-bordered-green"
                                href='/planos-e-precos/industrias-e-distribuidoras/'
                            >
                                Ver planos e preços
                            </a>
                        </div>
                        <p className="cta-bottom-text">
                            <span className="desktop-text">Teste grátis por 7 dias | Sem cobrança ao terminar o período grátis | Explore todos os recursos</span>
                            <span className="mobile-text">
                                Teste grátis por 7 dias<br />
                                Sem cobrança ao terminar o período grátis<br />
                                Explore todos os recursos
                            </span>
                        </p>
                    </div>

                    <div className="right-content">
                        <div className="testimonial">
                            <div className="author-avatar">
                                <Picture
                                    src="/images/site/depoimentos/rafael-vila-hr.png"
                                    alt="Alessandro Gonçalves"
                                    className="avatar-image"
                                />
                            </div>
                            <div className="testimonial-content">
                                <p className="testimonial-text">
                                    “Em pouco tempo, o Mercos já fez uma grande diferença: conseguimos construir históricos de compras, entender o que os clientes levam ou não e até recuperar uma linha de produtos que não estava saindo. Batemos nossas metas e seguimos crescendo.”
                                </p>

                                <div className="testimonial-author">
                                    <div className="author-info">
                                        <p className="author-name">Rafael Vila</p>
                                        <p className="author-position">Gerente comercial da Trato Vegano</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CallToActionSection


// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/CallToActionSection/CallToActionSection.jsx